import { PageSkeleton } from '@sellsen/components';
import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentRoles } from '../../hooks/use-current-roles';
import { isSellerRoleSet } from '../../hooks/use-is-seller';

/**
 * Satıcı (ROLE_SELLER / ROLE_ADMIN) sayfalarının route guard'ı. ASIN-only kullanıcı (yalnız
 * ROLE_USER) URL ile gelirse dashboard'a döner; menüde bu sayfalar zaten gösterilmez.
 */
export function RequireSellerAccess() {
  const { roles, isLoading } = useCurrentRoles();

  if (isLoading) {
    return <PageSkeleton />;
  }

  if (!isSellerRoleSet(roles)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
